import {useLocalStorage_DEPRECATED} from '@aboutyou/storage';
import React, {useContext, useEffect} from 'react';

export interface UserSessionCount {
  count: number;
  time: number;
}

interface SessionCountContextType {
  userSessionCount: UserSessionCount;
}

const SessionCountContext = React.createContext<SessionCountContextType>({
  userSessionCount: {count: 0, time: Date.now()},
});

export const USER_SESSION_COUNT_LOCAL_STORAGE_KEY = 'ay_session_count';

/**
 * It was decided that 30 minutes is a good indicator to determine a user session
 * during initial implementation of the returning user.
 * @param current
 * @param previous
 * @returns
 */
const moreThan30minutes = (current: number, previous: number) => {
  const expectedTimeToPass = 30 * 60 * 1000; // 30 mins
  return previous + expectedTimeToPass < current;
};

export const useUserSessionCount = () => useContext(SessionCountContext);

export const SessionCountProvider = ({children}: React.PropsWithChildren) => {
  const defaultValue = {count: 0, time: Date.now()};
  const [userSessionCount, setUserSessionCount] =
    // eslint-disable-next-line no-restricted-syntax
    useLocalStorage_DEPRECATED<UserSessionCount>({
      key: USER_SESSION_COUNT_LOCAL_STORAGE_KEY,
      defaultValue,
    });

  useEffect(() => {
    if (
      userSessionCount &&
      moreThan30minutes(defaultValue.time, userSessionCount.time)
    ) {
      // eslint-disable-next-line local-rules/set-state-in-use-effect -- TODO: Cleanup setState in useEffect https://aboutyou.atlassian.net/browse/ASFE-7602
      setUserSessionCount({
        count: userSessionCount.count + 1,
        time: defaultValue.time,
      });
    } else if (userSessionCount) {
      setUserSessionCount({
        ...userSessionCount,
      });
    }
  }, []);

  return (
    <SessionCountContext.Provider
      value={{
        userSessionCount: userSessionCount!,
      }}
    >
      {children}
    </SessionCountContext.Provider>
  );
};
